import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { buildCountyStats, buildHeroProofPoints } from "@/utils/directoryQuery";
import { devError } from "@/utils/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_COUNTS = { nutrition: 0, fitness: 0, recovery: 0, services: 0 };

export function useDirectorySupportData() {
  const [stats, setStats] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    Promise.all([
      axios.get(`${API}/listings/zone-stats`),
      axios.get(`${API}/reviews`),
      axios.get(`${API}/testimonials`),
    ]).then(([statsResponse, reviewsResponse, testimonialsResponse]) => {
      setStats(statsResponse.data);
      setReviews(reviewsResponse.data || []);
      setTestimonials(testimonialsResponse.data || []);
    }).catch((error) => devError("Failed to load directory support data:", error));
  }, []);
  const categoryCounts = useMemo(() => stats?.categoryCounts || EMPTY_COUNTS, [stats]);
  const countyStats = useMemo(() => buildCountyStats(stats), [stats]);
  const heroProofPoints = useMemo(() => buildHeroProofPoints(stats), [stats]);
  return {
    categoryCounts,
    countyStats,
    heroProofPoints,
    reviews,
    stats,
    testimonials,
    weeklyFeatured: stats?.weeklyFeatured || null,
  };
}